const INDUSTRY = [
  { id: 'Earthworks Construction', name: '土木・建設' },
  { id: 'Survey & Mapping', name: '測量・調査士' },
  { id: 'Agriculture', name: '農業' },
  { id: 'Paving Construction', name: '舗装工' },
  { id: 'Building Construction', name: '建築' },
  { id: 'OEM Manufacturing', name: 'OEM' },
];

export default INDUSTRY;
